<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  fieldModel: Object,
  disabled: Boolean,
  placeholder: String
})

const newTag = ref('')
const tags = computed(() => props.fieldModel.inputValue || [])
const tagsCount = computed(() => tags.value.length)

function addTag(tag) {
  if (!tag.trim().length) {
    newTag.value = ''
    return
  }

  if (!props.fieldModel.inputValue) {
    // eslint-disable-next-line
    props.fieldModel.inputValue = [tag]
    newTag.value = ''
  } else if (!props.fieldModel.inputValue.includes(tag)) {
    // eslint-disable-next-line
    props.fieldModel.inputValue.push(tag)
    newTag.value = ''
  }
}

function removeTag(index) {
  if (tagsCount.value > 0) {
    // eslint-disable-next-line
    props.fieldModel.inputValue.splice(index, 1)
  }
}
</script>

<template>
  <div
    class="form-field-tags-input gap-1"
    :class="{ 'is-invalid': fieldModel.hasErrors }"
  >
    <span
      v-for="(tag, index) in tags"
      :key="index"
      class="badge text-bg-light fs-6 fw-normal"
    >
      {{ tag }}
      <button
        class="delete fw-light"
        @click="removeTag(index)"
        :disabled="disabled"
      >
        x
      </button>
    </span>
    <input
      type="text"
      v-model="newTag"
      @keydown.enter="addTag(newTag)"
      @blur="newTag.length && addTag(newTag)"
      @keydown.delete="newTag.length || removeTag(tagsCount - 1)"
      :disabled="disabled"
      :placeholder="placeholder"
    />
  </div>
</template>

<style lang="scss" scoped>
.form-field-tags-input {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  input {
    flex: 1;
    background: transparent;
    border: none;
  }

  input:focus {
    outline: none;
  }

  .delete {
    color: inherit;
    background: none;
    outline: none;
    border: none;
    padding-right: 0;
    cursor: pointer;
  }
}
</style>
